module.exports = __webpack_public_path__ + "08d3948c906444c720f5d9404734e093.png";